export default __webpack_public_path__ + "static/media/m_diagram3_eng.a83d0cfa.png";